import Vue from 'vue'
import Antd from 'ant-design-vue'
import App from './App.vue'
import router from './router'
import store from './store'

import firebase from 'firebase/app';
import 'firebase/auth';

import 'ant-design-vue/dist/antd.css'

Vue.config.productionTip = false
Vue.use(Antd)

let app = null;

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
})

